<template>
  <Head>
    <meta
      property="og:image"
      content="https://api.gkosnova.tech/public/storage/media/2022/2/1200/DPl7ZjfCfILjU30qAkD1uzz7eN60iQIYgDLKJ1NO.jpg"
    />
    <meta property="og:url" :content="url" />
    <meta property="og:type" content="website" />
  </Head>
  <Header :key="isReplacedPhonePage ? 'gmb' : 'default'" />

  <CallButton v-if="mq.mdMinus" :key="isReplacedPhonePage ? 'gmb' : 'default'" />

  <router-view v-slot="{ Component }">
    <component :is="Component" :key="$route.path" />
  </router-view>

  <Footer />
  <modals-container />
  <PopupCookie />
</template>

<script>
import { is_touch } from "@/helpers.js";
import mainStore from "@/store/main.js";
import galleryStore from "@/store/gallery.js";
import genplanStore from "@/store/genplan.js";
import filterStore from "@/store/filter.js";
import favouritesStore from "@/store/favourites.js";
import captchaStore from "@/store/captcha.js";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { Head } from "@vueuse/head";
import { PopupWithChats } from "@adv/popup-with-chats";
import CallButton from "@/components/UI/CallButton.vue";
import PopupCookie from "@/components/PopupCookie.vue";
import { mindboxConfig } from "@/mindbox";
import { isReplacedRoute } from "@/utils/phones";

export default {
  components: {
    Head,
    Header,
    Footer,
    CallButton,
    PopupCookie,
  },
  inject: ["mq"],
  provide: {
    mainStore,
    galleryStore,
    genplanStore,
    filterStore,
    favouritesStore,
    captchaStore,
  },
  computed: {
    url() {
      return window.location.origin + "" + this.$route.path;
    },
    isReplacedPhonePage() {
      return isReplacedRoute(this.$route.name);
    },
    captchaVerified() {
      return captchaStore.state.captchaVerified;
    },
  },
  watch: {
    captchaVerified(verified) {
      if (verified) {
        this.initPopupWithChats();
      }
    },
  },
  mounted() {
    if (captchaStore.state.captchaVerified) {
      this.initPopupWithChats();
    }
    if (is_touch()) {
      document.body.classList.add("-istouch");
    } else {
      document.body.classList.add("-notouch");
    }
  },
  methods: {
    initPopupWithChats() {
      if (window.popupWithChats) return;
      
      const makePopup = () => {
        PopupWithChats.make("body", {
          callbackModalId: "popup-with-chats",
          successModalId: "success-popup-with-chats",
          agreementLink: "/Политика_обработки_персональных_данных.pdf",
          processingLink: "/data-consent",
          promotionLink: "/promotion",
          title: process.env.VUE_APP_POPUP_DEFAULT_TITLE,
          subtitle: process.env.VUE_APP_POPUP_SUBTITLE,
          messagerDescription: process.env.VUE_APP_POPUP_MESSAGER_DESC,
          disableTrackingScripts: true,
          mindbox: mindboxConfig,
        });
      };

      if (document.readyState === "complete") {
        makePopup();
      } else {
        window.addEventListener("load", makePopup, { once: true });
      }
    }
  }
};
</script>
<style>
@import "~@css/bootstrap.css";
@import "~@css/style.css";
@import "~@adv/popup-with-chats/dist/popup-with-chats.css";

.popup-with-chats .popup-with-chats__title {
  color: #ff0020;
  font-weight: 400;
  font-style: normal;
  font-size: 26px;
  font-family: "Gilroy", "Times New Roman", sans-serif;
  line-height: 96%;
  letter-spacing: 0.05em;
  text-transform: unset;
}

.popup-with-chats .popup-with-chats__subtitle {
  color: #666;
  font-weight: 400;
  font-style: normal;
  font-size: 10px;
  line-height: 132.5%;
  opacity: 0.7;
}

.popup-with-chats .popup-with-chats__input {
  color: #142654;
  font-weight: 400;
  font-size: 14px;
}

.popup-with-chats .popup-with-chats__agreement-link {
  border-color: #ff0020;
}

.popup-with-chats .popup-with-chats__agreement-link:hover {
  color: #ff0020;
}

.popup-with-chats .popup-with-chats__button {
  width: 100%;
  margin: 0;
  margin-top: 16px;
  border-color: #ff0020;
  border-radius: 32px;
  background: #ff0020;
}

.popup-with-chats .popup-with-chats__checkbox:checked {
  background-color: #ff0020;
  border-color: #ff0020;
}

.popup-with-chats .popup-with-chats__soc-button {
  border-color: #ff0020;
}

.popup-with-chats .popup-with-chats__soc-button:hover {
  color: #ff0020;
}

.popup-with-chats .popup-with-chats__soc-button .popup-with-chats__icon path {
  fill: #ff0020;
}

.popup-with-chats .popup-with-chats__field-input {
  height: auto;
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid #cbd0dd;
  border-radius: 0;
}

.popup-with-chats .popup-with-chats__field-input--error {
  border-bottom: 1px solid red;
}

.popup-with-chats .popup-with-chats__label {
  transition: none;
}

.popup-with-chats
  .popup-with-chats__field-input--with-content
  .popup-with-chats__label {
  display: none;
}

@media screen and (min-width: 768px) {
  .popup-with-chats .content-popup-with-chats__title {
    font-size: 32px;
  }

  .popup-with-chats .content-popup-with-chats__subtitle {
    font-size: 15px;
    line-height: 18px;
  }

  .popup-with-chats
    .content-popup-with-chats
    .form-content-popup-with-chats__button {
    width: calc(100% + 44px);
    margin-left: -22px;
  }
}

.popup-with-chats__social {
  display: none !important;
}
</style>
